import { Card, Stack, Theme, SxProps, Typography } from '@mui/material';
import { CircleBadge } from '@schooly/style';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { SystemStyleObject } from '@mui/system';

interface ImportStepCardProps extends PropsWithChildren {
  step: number;
  titleId: string;
  descriptionId: string;
  sx?: SxProps<Theme>;
}

export const ImportStepCard: FC<ImportStepCardProps> = ({
  step,
  titleId,
  descriptionId,
  children,
  sx,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Card
      sx={(theme) => ({
        p: 2,
        border: 'none',
        bgcolor: 'common.lightBg',
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
    >
      <Stack gap={1.5}>
        <Stack direction="row" alignItems="center" gap={2}>
          <CircleBadge sx={{ bgcolor: 'background.paper' }}>
            <Typography variant="h2">{step}</Typography>
          </CircleBadge>
          <Stack gap={0.5} flex={1}>
            <Typography variant="h2">{formatMessage({ id: titleId })}</Typography>
            <Typography variant="h3" color="common.grey2">
              {formatMessage({ id: descriptionId })}
            </Typography>
          </Stack>
        </Stack>
        {children}
      </Stack>
    </Card>
  );
};

interface TemplateFieldProps {
  icon: ReactNode;
  titleId: string;
  descriptionId: string;
}

export const TemplateField: FC<TemplateFieldProps> = ({ icon, titleId, descriptionId }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack direction="row" gap={2}>
      <CircleBadge sx={{ bgcolor: 'background.paper' }}>{icon}</CircleBadge>
      <Stack>
        <Typography variant="h3">{formatMessage({ id: titleId })}</Typography>
        <Typography color="common.grey2" sx={{ whiteSpace: 'pre-wrap' }}>
          {formatMessage({ id: descriptionId })}
        </Typography>
      </Stack>
    </Stack>
  );
};
